import { AxiosError, AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";

// Response / Request
import { KeyValueEnum } from "@/main/models/common";
import { Result } from "@models/common/resultResponse";

// Redux
import { GetReportScheduleStatus, saveReportScheduleStatus } from "./index";

// Api's
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { procurementReportScheduleStatusApi } from "../../api";

export function* getReportScheduleStatusSaga(_action: GetReportScheduleStatus) {
	try {
		const response: AxiosResponse<Result<KeyValueEnum[]>> = yield call(
			procurementReportScheduleStatusApi.getProcurementReportScheduleStatus,
		);

		if (response.data.result) {
			yield put(saveReportScheduleStatus(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveReportScheduleStatus(null, true, resultError.messagesDataError));
		}
	}
}
